import React from 'react';
import processImage from '../assets/images/Image_fx - 2025-10-26T130948.827.jpg';

const Process = () => {
  return (
    <section className="process_home_wrap u-grid-tablet">
      <div id="w-node-_33904072-3145-f0bb-530d-f3954b958a83-5ee71fd0" className="process_left_wrap">
        <div data-wf--global-eyebrow--variant="base" className="g_eyebrow u-text-small">Process</div>
        <div data-image-reveal="" className="process_left_cover">
          <div data-image-cover="" className="g_image_cover"></div>
          {processImage && (
            <img
              src={processImage}
              loading="lazy"
              data-image=""
              alt="A black and white of an architect overseeing the architectural site"
              className="process_left_image"
            />
          )}
        </div>
        <div className="process_left_collection w-dyn-list">
          <div role="list" className="process_left_list w-dyn-items">
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">스케치 디자인</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">디자인 개발</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">개발 허가 신청</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">인테리어 디자인</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">건축 인허가도 + 문서화</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
            <div role="listitem" className="process_left_item u-text-main w-dyn-item">
              <div className="process_left_contain">
                <div className="process_left_animate">
                  <div data-process-item="" className="process_left_index">(0<span data-process-value="" className="process_left_value">0</span>)</div>
                  <div className="process_left_title">시공도 + 문서화</div>
                </div>
              </div>
              <div className="process_left_line"></div>
            </div>
          </div>
        </div>
      </div>
      <div id="w-node-_76f99075-8b04-0f10-3283-03423b0659c6-5ee71fd0" className="process_aside_wrap">
        <p className="process_aside_paragraph u-text-h3 u-sr-only">
          저희 페르323의 방식은 아이디어 구상부터 완성까지 고객님의 여정을 가장 부드럽고 즐거운 과정이 되도록 설계되었습니다.
        </p>
        <p aria-hidden={true} data-lines-split="" data-animate-scroll="" className="process_aside_paragraph u-text-h3">
          저희 페르323의 방식은 아이디어 구상부터 완성까지 고객님의 여정을 가장 부드럽고 즐거운 과정이 되도록 설계되었습니다.
          <br />
          <span aria-hidden={true} className="u-splittext-spacer"></span>
          총 6단계 프로세스를 통해, 저희는 명확성, 긴밀한 협력, 그리고 고객님의 고유한 비전을 최우선으로 합니다. 모든 단계에서 고객님께 정보를 공유하며 영감을 드리고 적극적으로 참여하실 수 있도록 합니다.
        </p>
      </div>
    </section>
  );
};

export default Process;